document.addEventListener('click', function (e) {
  const btn = e.target.closest('.js-toggle-favorite');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  const propertyId = btn.dataset.propertyId;
  let favorites = getFavorites();

  if (favorites.includes(propertyId)) {
    favorites = favorites.filter(id => id !== propertyId);
    btn.classList.remove('active');
  } else {
    favorites.push(propertyId);
    btn.classList.add('active');
  }

  updateJsFavoritesCount(favorites.length);

  setFavorites(favorites);
});

function getFavorites() {
  const cookie = document.cookie
    .split('; ')
    .find(row => row.startsWith('favorite_properties='));
  return cookie ? JSON.parse(decodeURIComponent(cookie.split('=')[1])) : [];
}

function setFavorites(favorites) {
  document.cookie = `favorite_properties=${encodeURIComponent(JSON.stringify(favorites))}; path=/; max-age=${60 * 60 * 24 * 365}`;
}

function updateJsFavoritesCount(count) {
  const favoritesCountElements = document.querySelectorAll('.js-favorites-count');
  favoritesCountElements.forEach(el => {
    el.textContent = `(${count})`;
  });
}
updateJsFavoritesCount(getFavorites().length);